export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8608.c1d57234.jpg";